/**
 * Fragenkarte (Fragenmodus, didaktisches Herzstück) — 1:1 zur Web-App:
 * Nummer, Fragetext in „…", Aktionen (erledigt-Checkbox, Frage kopieren)
 * und aufklappbarer Antwort-Hinweis (default zugeklappt).
 * „eigene" Fragen in Orange.
 */
import type { Question } from "../data/types";
import { contentKey, isDone, toggleDone } from "../state/progress";
import { isHintRevealed, toggleHint } from "../state/ui";
import { askQuestion, openPromptDialog } from "../state/coach";
import { showToast } from "../ui/toast";
import { IconSparkles } from "../app/icons";

interface Props {
  question: Question;
  index: number;
  courseId: string;
  moduleId: string;
  blockId: string;
}

export function QuestionCard({ question: q, index, courseId, moduleId, blockId }: Props) {
  const doneKey = contentKey(moduleId, blockId, "question", q.id);
  const hintKey = doneKey;
  const done = isDone(doneKey);
  const hintOpen = isHintRevealed(hintKey);

  function onToggleDone() {
    void toggleDone({ courseId, moduleId, blockId, itemId: q.id, itemType: "question" });
  }
  function onCopy() {
    void navigator.clipboard?.writeText(q.text).then(() => showToast("Frage kopiert ✓"));
  }
  // Frage an die Kurs-KI: mit [Platzhaltern] ins Eingabefeld setzen (nicht senden),
  // sonst direkt fragen — wie die Web-Klick-Bindung der Fragenkarte.
  function onAsk() {
    if (/\[[^\]]+\]/.test(q.text)) openPromptDialog(q.text);
    else void askQuestion(q.text);
  }

  return (
    <article class={`qcard glass${q.own ? " eigene" : ""}${done ? " done" : ""}`}>
      <div class="qtop">
        <div class="qnum">{index}</div>
        <div class="qbody">
          {q.own ? <span class="badge">Deine eigene Frage</span> : null}
          <p class="qtext">„{q.text}"</p>
          <div class="qactions">
            <button type="button" class="btn-coach qask-send" onClick={onAsk}>
              <IconSparkles size={15} /> An KI senden
            </button>
            <label class="check">
              <input type="checkbox" checked={done} onChange={onToggleDone} />
              <span class="box" />
              <span class="lbl">erledigt</span>
            </label>
            <button type="button" class="btn-copy" onClick={onCopy}>
              Frage kopieren
            </button>
          </div>
          {q.hint ? (
            <details class="mitnehmen" open={hintOpen}>
              <summary onClick={(e) => { e.preventDefault(); toggleHint(hintKey); }}>
                <span class="tag">Antwort-Hinweis</span> anzeigen
              </summary>
              <p>{q.hint}</p>
            </details>
          ) : null}
        </div>
      </div>
    </article>
  );
}
